import { FREE } from 'self-service-api/constants/ProductLevels';
import { useAppSelector } from '../reducers';
import { highestProductLevelFromSkuIdsSelector } from '../selectors/ProductsSelectors';
import { useHighestProductLevelFromInventory } from '../v2/hooks/inventory/useHighestProductLevel';
export const useTrackingFlow = ({
  productConfigurations,
  purchaseMotion
}) => {
  const {
    highestProductLevel: highestOwnedProductLevel
  } = useHighestProductLevelFromInventory();
  const flow = useAppSelector(state => {
    const highestSelectedProductLevel = highestProductLevelFromSkuIdsSelector(state, {
      skuIds: productConfigurations.map(({
        skuId
      }) => skuId)
    });
    if (!highestSelectedProductLevel || !highestOwnedProductLevel || highestSelectedProductLevel === FREE // anything-to-free is not a valid flow
    ) {
      return '';
    }
    if (['BUY_TOUCHLESS', 'REQUEST_PRODUCT', 'TALK_TO_SALES'].includes(String(purchaseMotion))) {
      return `${highestOwnedProductLevel}-to-${highestSelectedProductLevel}`.toLowerCase();
    }
    return '';
  });
  return flow;
};